import { TouchableOpacity, Text, ActivityIndicator, StyleSheet } from 'react-native'
import type { RewardOption } from './useRewardOptions'
import { mesaColorNames, typography } from '@/src/common/theme'
import { useState, type ComponentProps } from 'react'
import { ComingSoon } from './ComingSoon'
import { useMediaQuery } from 'react-responsive'
import { useLogError } from '@/src/common/hooks/useLogError'
import { DesignSystem } from '@/src/design-system'

export function RewardOptionEntryPoint({
  rewardOption,
  style,
}: { rewardOption: RewardOption } & Pick<ComponentProps<typeof TouchableOpacity>, 'style'>) {
  const [loading, setLoading] = useState(false)
  const minWidth500 = useMediaQuery({ minWidth: 500 })
  const logError = useLogError()

  return (
    <TouchableOpacity
      style={[styles.rewardOptionEntryPoint, style]}
      disabled={rewardOption.hasComingSoonOverlay}
      onPress={() => {
        void (async () => {
          try {
            setLoading(true)

            await rewardOption.onOpen()
          } catch (error) {
            logError('error opening reward option', error)
          } finally {
            setLoading(false)
          }
        })()
      }}
    >
      <DesignSystem.Card
        style={[styles.rewardOptionCard, { paddingHorizontal: minWidth500 ? 16 : 8 }]}
      >
        {loading && <ActivityIndicator size="large" style={styles.rewardOptionLoading} />}
        {rewardOption.hasComingSoonOverlay && <ComingSoon style={styles.comingSoon} />}
        {rewardOption.icon}
        <Text style={styles.rewardOptionTitle}>{rewardOption.title}</Text>
      </DesignSystem.Card>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  rewardOptionEntryPoint: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'stretch',
    aspectRatio: 1,
  },
  rewardOptionLoading: {
    position: 'absolute',
    borderRadius: 15,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
  rewardOptionTitle: {
    ...typography['label/xs-regular'],
    minHeight: 28,
    marginTop: 8,
    color: mesaColorNames['Mesa - Brand/Blackish #222222'],
    textAlign: 'center',
  },
  rewardOptionCard: {
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
  },
  comingSoon: {
    position: 'absolute',
    top: 8,
    zIndex: 1,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
})
